// extracted by mini-css-extract-plugin
export var content = "_pr-1";
export var fullScreen = "_pr-0";